(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'EmailBuilderCustomContent',
	};

	var form_id            = 'emailbuildercustomcontent-';
	var custom_image_sizes = {
		left_right: {
			width : 215,
			height: 300,
		},
		top_bottom: {
			width : '',
			height: '',
		}
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// when changing the position of a custom image
		$('#' + form_id + 'image_position').on('change', function onImagePositionChange(e) {
			var position          = $(this).val();
			var $image_file_input = $('#' + form_id + 'custom_image');

			// reset attributes and hidden fields from image cropper
			$image_file_input.off().val('');
			$image_file_input.siblings('.cropper-data').remove();

			$image_file_input.attr({
				'data-form-width' : custom_image_sizes[position]['width'],
				'data-form-height': custom_image_sizes[position]['height'],
				name              : $image_file_input.next().attr('name'),
			});

			$image_file_input.data({
				'form-width' : custom_image_sizes[position]['width'],
				'form-height': custom_image_sizes[position]['height'],
			});

			$image_file_input.next().remove();

			// reinit the image cropper
			Adzuki.ImageCropper($image_file_input);
		});
	};
}(jQuery, window.Adzuki || {}));
